import { createContext } from "react";

export const FrameContext = createContext(null);
